<template>
  <snack-bar class="cashflow-state-bar" v-if="barText"
             :text="barText"
             :variant="barVariant">
    <template v-slot:secondary>
      <div v-if="lastUpdatedText" class="text">{{ lastUpdatedText }}</div>
    </template>
  </snack-bar>
</template>

<script>
import moment from 'moment';
import BaseUI from 'base-ui';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'CashflowStateBar',
  components: {
    SnackBar: BaseUI.SnackBar,
  },
  computed: {
    ...mapState('applicationState', ['barState', 'cashflowState']),
    ...mapGetters('applicationState', ['barTypes', 'cashflowTypes']),
    ...mapGetters('cashflowView', ['isPresentingCurrentMonth', 'budgetUpdatedAt']),

    formatedUpdateTime() {
      return moment(this.budgetUpdatedAt).format('DD.M.YY, H:mm');
    },
    barText() {
      if (this.barState === this.barTypes.OUT_OF_DATE) {
        return 'התזרים לא מעודכן';
      }
      if (this.barState === this.barTypes.NOT_ACCURATE) {
        return 'שימו לב, התזרים אינו מדויק';
      }
      if (this.barState === this.barTypes.NOT_AVAILABLE) {
        return 'התזרים לא זמין כעת';
      }
      if (this.barState === this.barTypes.PROCESSING) {
        return 'הנתונים בבדיקה, ייתכן והתזרים לא מדויק.';
      }
      return null;
    },
    lastUpdatedText() {
      return (this.cashflowState === this.barTypes.OUT_OF_DATE && this.budgetUpdatedAt) ? `עידכון אחרון: ${this.formatedUpdateTime}` : null;
    },
    barVariant() {
      if (this.barState === this.barTypes.PROCESSING) {
        return 'warning';
      }
      return 'danger';
    },
  },
  methods: {},
};

</script>

<style scoped lang="scss">
  @import '../scss/mixins';

  .cashflow-state-bar {
    @include responsive-padding;
  }
</style>



// WEBPACK FOOTER //
// src/base-components/CashflowStateBar.vue